/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { EvaluationParameterDto } from './EvaluationParameterDto';
import {
    EvaluationParameterDtoFromJSON,
    EvaluationParameterDtoFromJSONTyped,
    EvaluationParameterDtoToJSON,
} from './EvaluationParameterDto';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { BeamAnalysisWorkResultDto } from './BeamAnalysisWorkResultDto';
import {
    BeamAnalysisWorkResultDtoFromJSON,
    BeamAnalysisWorkResultDtoFromJSONTyped,
    BeamAnalysisWorkResultDtoToJSON,
} from './BeamAnalysisWorkResultDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface BeamAnalysisWorkStepDto
 */
export interface BeamAnalysisWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkStepDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkStepDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ParameterCombinationDto}
     * @memberof BeamAnalysisWorkStepDto
     */
    combination?: ParameterCombinationDto;
    /**
     * 
     * @type {Array<EvaluationParameterDto>}
     * @memberof BeamAnalysisWorkStepDto
     */
    evaluations?: Array<EvaluationParameterDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BeamAnalysisWorkStepDto
     */
    isExecutable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    workStepPreviewId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BeamAnalysisWorkStepDto
     */
    evaluationIds?: Array<string> | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof BeamAnalysisWorkStepDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {WorkState}
     * @memberof BeamAnalysisWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamAnalysisWorkStepDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkStepDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisWorkStepDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamAnalysisWorkStepDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof BeamAnalysisWorkStepDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {Array<BeamAnalysisWorkResultDto>}
     * @memberof BeamAnalysisWorkStepDto
     */
    results?: Array<BeamAnalysisWorkResultDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisWorkStepDto
     */
    $type?: BeamAnalysisWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisWorkStepDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationJobExecutionDtoBeamAnalysisWorkStepDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisWorkStepDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisWorkStepDtoTypeEnum = typeof BeamAnalysisWorkStepDtoTypeEnum[keyof typeof BeamAnalysisWorkStepDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisWorkStepDto interface.
 */
export function instanceOfBeamAnalysisWorkStepDto(value?: unknown): value is BeamAnalysisWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisWorkStepDtoTypeEnum)[0];
}

export function BeamAnalysisWorkStepDtoFromJSON(json: any): BeamAnalysisWorkStepDto {
    return BeamAnalysisWorkStepDtoFromJSONTyped(json, false);
}

export function BeamAnalysisWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisWorkStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'combination': json['combination'] == null ? undefined : ParameterCombinationDtoFromJSON(json['combination']),
        'evaluations': json['evaluations'] == null ? undefined : ((json['evaluations'] as Array<any>).map(EvaluationParameterDtoFromJSON)),
        'isExecutable': json['isExecutable'] == null ? undefined : json['isExecutable'],
        'workStepPreviewId': json['workStepPreviewId'] == null ? undefined : json['workStepPreviewId'],
        'evaluationIds': json['evaluationIds'] == null ? undefined : json['evaluationIds'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'workState': json['workState'] == null ? undefined : WorkStateFromJSON(json['workState']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'commentEntityCompositeId': json['commentEntityCompositeId'] == null ? undefined : json['commentEntityCompositeId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(BeamAnalysisWorkResultDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisWorkStepDtoToJSON(value?: Omit<BeamAnalysisWorkStepDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'combination': ParameterCombinationDtoToJSON(value['combination']),
        'evaluations': value['evaluations'] == null ? undefined : ((value['evaluations'] as Array<any>).map(EvaluationParameterDtoToJSON)),
        'isExecutable': value['isExecutable'],
        'workStepPreviewId': value['workStepPreviewId'],
        'evaluationIds': value['evaluationIds'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'workState': WorkStateToJSON(value['workState']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'commentEntityCompositeId': value['commentEntityCompositeId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(BeamAnalysisWorkResultDtoToJSON)),
        '$type': value['$type'],
    });
}

